import React from 'react';
import {PulseLoader} from 'react-spinners';

const SpinnerBox = () =>  
<div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0 , 0, 0, 0.2)',
            zIndex: 9999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
            <PulseLoader
  color="#0B1628"
  size="25px"
  cssOverride={{position:"absolute" , top:"45%", left:"50%"}}
/>

        </div>

export {  SpinnerBox };